import { Helmet } from 'react-helmet-async';
import { SITE_NAME } from '@/constants/site';

interface SEOHeadProps {
  title: string;
  description: string;
  canonical: string;
  ogImage?: string;
  imageAlt?: string;
  ogType?: 'website' | 'article';
  schema?: object;
}

const SEOHead = ({
  title,
  description,
  canonical,
  ogImage,
  imageAlt = 'Exemple de tableau photo personnalisé Ma Photo en Tableau',
  ogType = 'website',
  schema,
}: SEOHeadProps) => {
  const defaultImage = 'https://www.maphotoentableau.fr/site-assets/hero-background.jpg';
  const socialImage = ogImage ?? defaultImage;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:image" content={socialImage} />
      <meta property="og:image:alt" content={imageAlt} />
      <meta property="og:type" content={ogType} />
      <meta property="og:site_name" content={SITE_NAME} />
      <meta property="og:locale" content="fr_FR" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={socialImage} />
      <meta name="twitter:image:alt" content={imageAlt} />
      {schema && (
        <script type="application/ld+json">{JSON.stringify(schema)}</script>
      )}
    </Helmet>
  );
};

export default SEOHead;
